function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { connect } from 'react-redux';
import { Container, Modal, ModalBody, ModalHeader } from "reactstrap";
import styled from "styled-components";
import { assignImageEditorImage64, initImageEditor } from "../../../../redux/ui/imageEditor/imageEditorActions";
import { VerticalCentered } from "../../styled/VerticalCentered";
import FileSelect from "../../general/FileSelect";
import BlankSpace from "../../styled/BlankSpace";
import FileDrop from "../../general/FileDrop";
import ImageEditor from "../../general/ImageEditor";
const StyledContainer = styled(Container)`
  min-height: 20rem;
`;

class OperateImageModal extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "resetForm", () => {
      this.props.initImageEditor();
    });

    _defineProperty(this, "handleFileDropped", (file, fileBase64) => {
      this.props.assignImageEditorImage64({
        image64: fileBase64
      });
    });

    _defineProperty(this, "renderCurrentImage", () => {
      return /*#__PURE__*/React.createElement(VerticalCentered, null, /*#__PURE__*/React.createElement(FileSelect, {
        onSelectFile: this.onSelectFile,
        accept: 'image/*'
      }, this.props.children), /*#__PURE__*/React.createElement(BlankSpace, {
        rem: 2
      }), /*#__PURE__*/React.createElement("p", {
        className: "text-muted text-center"
      }, "Click Image or Drop File Here"));
    });

    _defineProperty(this, "renderImageEditor", () => {
      const {
        handleImageSubmit,
        children,
        ...props
      } = this.props;
      return /*#__PURE__*/React.createElement(ImageEditor, _extends({
        crop: {
          unit: '%',
          width: 50,
          height: 50,
          x: 25,
          y: 2,
          aspect: 1
        },
        onSelectFile: this.onSelectFile,
        handleImageSubmit: handleImageSubmit
      }, props));
    });

    _defineProperty(this, "onSelectFile", e => {
      if (e.target.files && e.target.files.length > 0) {
        const reader = new FileReader();
        reader.addEventListener('load', () => this.props.assignImageEditorImage64({
          image64: reader.result
        }));
        reader.readAsDataURL(e.target.files[0]);
      }
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(Modal, {
        className: 'modal-dialog-centered',
        size: 'lg',
        isOpen: this.props.modal,
        toggle: this.props.toggle,
        onClosed: this.resetForm,
        onClick: e => e.stopPropagation()
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: this.props.toggle
      }, "Edit Image"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(FileDrop, {
        handleFileDropped: this.handleFileDropped
      }, this.props.image64 ? this.renderImageEditor() : this.renderCurrentImage()))));
    });
  }

}

function mapStateToProps(state) {
  return {
    image64: state.ui.imageEditor.image64
  };
}

export default connect(mapStateToProps, {
  initImageEditor,
  assignImageEditorImage64
})(OperateImageModal);